import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import {
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Card,
  CardContent,
  CardHeader,
  Divider
} from '@mui/material';
import { useAuthContext } from '../../../hooks/useAuthContext';
import axios from '../../../services/ApiService';
import LoadingSpinner from '../../support/LoadingSpinner';
import toast from 'react-hot-toast';

interface WorkflowPayment {
  invoiceNumber: string;
  workflowName: string;
  programName: string;
  amount: number;
  status: string;
  dueDate: string;
  paidDate?: string;
}

function AgentBilling() {
  const [payments, setPayments] = useState<WorkflowPayment[]>([]);
  const [loading, setLoading] = useState(false);
  const { user } = useAuthContext();

  useEffect(() => {
    fetchPayments();
  }, []);

  const fetchPayments = async () => {
    if (!user) return;
    
    setLoading(true);
    try {
      // Uncomment when API is ready
      // const response = await axios.get('/getBusinessPayments');
      // setPayments(response.data);
      setPayments([]); // Remove this when API is ready
    } catch (error) {
      console.error('Error fetching payments:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>BVT Agent - Payments</title>
      </Helmet>
      {loading ? (
        <LoadingSpinner loading={loading} />
      ) : (
        <Stack spacing={3}>
          <Card>
            <CardHeader 
              subheader="Workflow Payments" 
              title="Payments"
            />
            <Divider />
            <CardContent>
              <TableContainer component={Paper} elevation={0}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Invoice #</TableCell>
                      <TableCell>Workflow Name</TableCell>
                      <TableCell>Program Name</TableCell>
                      <TableCell align="right">Amount</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell>Due Date</TableCell>
                      <TableCell>Paid Date</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {payments.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={7} align="center">
                          No payments found
                        </TableCell>
                      </TableRow>
                    ) : (
                      payments.map((payment, index) => (
                        <TableRow key={index}>
                          <TableCell>{payment.invoiceNumber}</TableCell>
                          <TableCell>{payment.workflowName}</TableCell>
                          <TableCell>{payment.programName}</TableCell>
                          <TableCell align="right">
                            {payment.amount.toFixed(2)}
                          </TableCell>
                          <TableCell>
                            <Chip 
                              label={payment.status}
                              color={payment.status.toUpperCase() === 'PAID' ? 'success' : 'warning'}
                              size="small"
                            />
                          </TableCell>
                          <TableCell>
                            {new Date(payment.dueDate).toLocaleDateString()}
                          </TableCell>
                          <TableCell>
                            {payment.paidDate 
                              ? new Date(payment.paidDate).toLocaleDateString() 
                              : '-'}
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
          </Card>
        </Stack>
      )}
    </>
  );
}

export default AgentBilling; 